// extracted by mini-css-extract-plugin
export var checkboxSpaceReservedMCL = "fRP89";
export var checkboxSpaceReservedMCLCompact = "Z208X";
export var checkboxSpaceReservedSCL = "cFDUn";
export var clickableRollup = "cFTRZ";
export var column = "aJ3Jj";
export var compact = "NISFx";
export var conversationView = "xbLFQ";
export var dismissButton = "gkHl_";
export var firstColumnNoTwisty = "SqNnV";
export var focusedOtherRollup = "oaecg";
export var full = "IBFua";
export var hoverColumnMCLAdjustments = "ZoN5c";
export var imageBackground = "D7ab_";
export var imageContainer = "ELhff";
export var imageContainerMCLCompact = "EV0yy";
export var imageContainerMCLFull = "fynX7";
export var imageContainerMCLMedium = "kiYj7";
export var imageContainerSCLCompact = "OYic8";
export var imageContainerSCLFull = "XQH4u";
export var imageContainerSCLMedium = "wuIrm";
export var imageContainerWithoutImage = "q2IjU";
export var itemView = "vJnHD";
export var mcl = "H1Ko8";
export var medium = "RUCeh";
export var monTypeRampStyles = "vvt1T";
export var scl = "EGJMx";
export var secondColumn = "lHMV6";
export var senderImageOff = "V0YIV";
export var senderImageOn = "l9k18";
export var slvRollupContainer = "sIfAW";
export var standardizedFirstColumn = "Ur0Bd";
export var standardizedSecondColumn = "WJmFZ";
export var text = "e_37D";
export var threeColumnClickableRollupCompact = "EJAAL";
export var threeColumnClickableRollupFull = "Ls4b8";
export var threeColumnClickableRollupMedium = "PJ_Wg";
export var threeColumnRollupContainer = "dFpOt";